import styled from 'styled-components';
import { LocalizedText } from '@mews/framework';
import { OptimusPlainLink } from '@mews-commander/ui';
import { Icon, getToken, getSpacingToken } from '@optimus-web/core';

export const DashboardFontIcon = styled(Icon).attrs({
    variant: 'basic',
})`
    margin-right: ${getSpacingToken('100')}px;
    vertical-align: middle;
`;

export const DashboardLinkElement = styled(OptimusPlainLink)`
    display: block;
    margin-bottom: ${getSpacingToken('50')}px;
    width: fit-content;
`;

export const DashboardTextElement = styled(LocalizedText)`
    color: ${getToken('textStaticPrimary')};
`;
